// whenTypes

// execute transformation w/ a probability calculated at start of loop
export const PROBABILITY = "PROBABILITY";
// execute transformation every N many loops
export const EVERY = "EVERY";
// allows a transformation to be dependent on another transformation
export const MARKOV = "MARKOV"; 

// allows a transformation to be dependent on another transformation's state
// in the PREVIOUS loop
export const MARKOV_PREVIOUS = "MARKOV_PREVIOUS"; 

// thenTypes
export const GATE_MASK = "GATE_MASK";
export const REVERSE = "REVERSE";
export const LEGATO = "LEGATO";
export const DELAY = "DELAY";
export const TRANSPOSE = "TRANSPOSE";
export const DURATION = "DURATION";
export const EXPAND = "EXPAND";
export const ROLL = "ROLL";
export const SCRIPT = "SCRIPT";

export const NEEDS_VALUE = [
    TRANSPOSE, DELAY, EXPAND, DURATION
];

export const ORDER_OF_OPERATIONS = [
    REVERSE, TRANSPOSE, DURATION, GATE_MASK, DELAY, EXPAND, ROLL, LEGATO
];

export const getTransformRange = (type) => {
    if (type === EXPAND) {
        return {min: 0, max: 4, step: 0.25};
    } else if (type === DELAY) {
        return {min: 0, max: 16, step: 1};
    } else if (type === DURATION) {
        return {min: 0, max: 4, step: 0.01};
    } else {
        return {min: -32, max: 32, step: 1};
    }
}

export const WHEN_OPTIONS = [
    {label: "Every", value: EVERY},
    {label: "Markov", value: MARKOV},
    {label: "Probability", value: PROBABILITY},
];

export const THEN_OPTIONS = [
    {label: "Delay", value: DELAY},
    {label: "Duration", value: DURATION},
    {label: "Expand", value: EXPAND},
    {label: "Gate Mask", value: GATE_MASK},
    {label: "Legato", value: LEGATO},
    {label: "Reverse", value: REVERSE},
    {label: "Roll", value: ROLL},
    {label: "Script", value: SCRIPT},
    {label: "Transpose", value: TRANSPOSE},
];

